<template>
  <EditForm :question="question" :editing="true"/>
</template>

<script>
import EditForm from '@/pages/admin/questions/thematic/EditForm'
import ThematicQuestionService from '@/services/ThematicQuestionService'

export default {
  props: {
    id: String
  },
  data: () => ({
    question: ThematicQuestionService.getDefaultItem(),
    thematicQuestionService: undefined
  }),
  components: {EditForm},
  created () {
    this.thematicQuestionService = new ThematicQuestionService(this.$store)
    this.thematicQuestionService.getItem(this.id, (data) => {
      this.question = data.question
    })
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/admin/questions/thematic/Edit.vue